exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-right[data-v-3f236185] {\n  height: 100%;\n}\n.right-box[data-v-3f236185] {\n  width: 100%;\n  height: 90%;\n}\n.system-details[data-v-3f236185] {\n  margin-left: 100px;\n  width: 100%;\n  height: 100%;\n}\n.system-details .header[data-v-3f236185] {\n  width: 100%;\n  margin-bottom: 20px;\n}", ""]);

// exports
